export const expand = () => (
  <path
    d="M15 3h6m0 0v6m0-6l-7 7M9 21H3m0 0v-6m0 6l7-7"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
